/**
 * Reditus referral widget loader.
 * The Reditus tracking script (which provides window.gr) is loaded via GTM in production
 * and via a <script> tag in public/index.html for local development.
 * Docs: https://docs.getreditus.com/referral-program/loading
 * This module checks for window.gr and falls back to mock mode if unavailable.
 */
import config from '@/config'

let widgetReady = false
let mockMode = false

const isReditusConfigured = () => !!config.reditusProductId

/**
 * Ensures the Reditus tracking script (window.gr) is available.
 * The tracking script should already be installed on the page (via index.html or GTM).
 * If window.gr is not found, enters mock mode.
 */
export const loadReditusScript = () => {
  if (!isReditusConfigured()) {
    mockMode = true
    widgetReady = true
    return Promise.resolve()
  }

  // The Reditus pageview tracking script provides window.gr
  // It should already be loaded on the page
  if (window.gr) {
    return Promise.resolve()
  }

  // window.gr not available — enter mock mode
  mockMode = true
  widgetReady = true
  return Promise.resolve()
}

export const initReditusWidget = (productId, authToken, userDetails) => {
  if (mockMode) {
    widgetReady = true
    return true
  }
  if (!window.gr) return false
  window.gr('loadReferralWidget', {
    product_id: productId,
    auth_token: authToken,
    user_details: userDetails,
  })
  widgetReady = true
  return true
}

export const showReditusWidget = () => {
  if (mockMode) return 'mock'
  if (window.referralWidget) {
    window.referralWidget.show()
    return true
  }
  return false
}

export const isWidgetReady = () => widgetReady
export const isMockMode = () => mockMode

export const resetState = () => {
  widgetReady = false
  mockMode = false
}
